import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationMessageText } from '../../models/user.model';
import {
  UntypedFormGroup,
  UntypedFormControl,
  FormBuilder,
} from '@angular/forms';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  // createLoading = false;
  form: UntypedFormGroup;
  module = '';
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      message: ConfirmationMessageText;
      module: string;
    }
  ) {
    this.form = this.fb.group({
      showUsd: new UntypedFormControl(false),
    });
    this.module = data.module;
  }
  onSubmit() {
    if (this.module === 'FINANCE') {
      if (this.form.valid) {
        this.dialogRef.close({
          showUsd: this.form.value.showUsd,
        });
      }
    } else {
      // Other modules (NO FORM) → Return simple true
      this.dialogRef.close(true);
    }
  }
}
